import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideWorkflow = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={8} height={8} x={3} y={3} rx={2} />
      <path d="M7 11v4a2 2 0 0 0 2 2h4" />
      <rect width={8} height={8} x={13} y={13} rx={2} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideWorkflow);
const Memo = memo(ForwardRef);
export default Memo;
